import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useState } from "react";
import type { FilterRenderProps } from "../../grid/CompGrid";
import type { GridTextFilter, GridTextFilterMode } from "../../../types/filters";

export interface GridMessageFilterPopoverProps extends FilterRenderProps {
  label?: string;
}

const MODES: { value: GridTextFilterMode; label: string }[] = [
  { value: "contains", label: "Contains" },
  { value: "prefix", label: "Prefix" },
  { value: "suffix", label: "Suffix" },
  { value: "equals", label: "Equals" },
];

export function GridMessageFilterPopover({
  value,
  onChange,
  label = "Message",
}: GridMessageFilterPopoverProps) {
  const filters = (Array.isArray(value) ? value : []) as GridTextFilter[];
  const [text, setText] = useState(filters[0]?.text ?? "");
  const [mode, setMode] = useState<GridTextFilterMode>(filters[0]?.mode ?? "contains");

  const handleApply = () => {
    const t = text.trim();
    if (!t) {
      onChange([]);
      return;
    }
    onChange([{ text: t, mode }]);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, minWidth: 220 }}>
      <TextField
        size="small"
        label={label}
        placeholder="Filter text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={handleApply}
        onKeyDown={(e) => e.key === "Enter" && handleApply()}
      />
      <FormControl size="small">
        <InputLabel>Mode</InputLabel>
        <Select
          value={mode}
          label="Mode"
          onChange={(e) => {
            setMode(e.target.value as GridTextFilterMode);
            if (text.trim()) {
              onChange([{ text: text.trim(), mode: e.target.value as GridTextFilterMode }]);
            }
          }}
        >
          {MODES.map((m) => (
            <MenuItem key={m.value} value={m.value}>
              {m.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
